export const media_host =
  "https://unvtloluuxmtqcbtqmpb.supabase.co/storage/v1/object/public/media/";
